import { api } from "../api";
import { BASE_SERVER_PATH } from "../../constant";
import {
  BatchPriceCardsCardMarketResponseType,
  BatchPriceCardsCardTraderResponseType,
  BatchPriceCardsRequestType,
  BatchPriceCardsResponseCardMarketAvarageType,
} from "magic-shared-types";

export const myServerApis = api.injectEndpoints({
  endpoints: (builder) => ({
    batchPriceCardsCardTrader: builder.mutation<
      {
        pricedCards: BatchPriceCardsCardTraderResponseType[];
      },
      {
        cards: BatchPriceCardsRequestType[];
        strategyId: number;
        applyOnlyIfGreater: boolean;
        applyOnlyIfSmaller: boolean;
        maximumPercentageDecreasePrice?: number;
        maximumPercentageIncreasePrice?: number;
      }
    >({
      query: (body) => ({
        url: `${BASE_SERVER_PATH}/api/price-cards/batch-cardtrader`,
        method: "POST",
        body,
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
    batchPriceCardsCardMarket: builder.mutation<
      {
        pricedCards: BatchPriceCardsCardMarketResponseType[];
      },
      {
        cards: BatchPriceCardsRequestType[];
        strategyId: number;
        applyOnlyIfGreater: boolean;
        applyOnlyIfSmaller: boolean;
        maximumPercentageDecreasePrice?: number;
        maximumPercentageIncreasePrice?: number;
      }
    >({
      query: (body) => ({
        url: `${BASE_SERVER_PATH}/api/price-cards/batch-cardmarket`,
        method: "POST",
        body,
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
    batchPriceCardsCardMarketTrend: builder.mutation<
      {
        pricedCards: BatchPriceCardsResponseCardMarketAvarageType[];
      },
      {
        cards: BatchPriceCardsRequestType[];
        avgStrategy: string;
        applyOnlyIfGreater: boolean;
        applyOnlyIfSmaller: boolean;
        percentage: number;
        minPrice: number;
        maximumPercentageDecreasePrice?: number;
        maximumPercentageIncreasePrice?: number;
      }
    >({
      query: (body) => ({
        url: `${BASE_SERVER_PATH}/api/price-cards/batch-cardmarket-trend`,
        method: "POST",
        body,
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
  }),
});

export const {
  useBatchPriceCardsCardMarketMutation,
  useBatchPriceCardsCardTraderMutation,
  useBatchPriceCardsCardMarketTrendMutation,
} = myServerApis;
